var isResettingPrice = false;

window.category =
{
    bindFilterForm: function (form)
    {
        var checkboxes = form.querySelectorAll("input[type=checkbox]");

        checkboxes.forEach(function (checkbox)
        {
            checkbox.addEventListener("change", async function (e)
            {
                await submitAjaxForm(form);

                price.asyncPrice();
            });
        });

        var rangeSliders = form.querySelectorAll("[data-range-slider]");

        for (var rangeSlider of rangeSliders)
        {
            var rangeSliderUi = rangeSlider.querySelector(".range-slider-ui");

            if (rangeSliderUi && !rangeSliderUi.noUiSlider)
                window.cartzilla.createRangeSliderWidget(rangeSlider);
        }

        var priceFilter = form.querySelector("#price-filter");

        if (priceFilter)
            category.bindPriceFilter(priceFilter, form);
    },
    bindPriceFilter: function (priceFilter, form)
    {
        window.category._filterForm = form;

        var inputMin = priceFilter.querySelector("input[data-range-slider-min]");
        var inputMax = priceFilter.querySelector("input[data-range-slider-max]");
        var noUiSliderElement = priceFilter.querySelector(".range-slider-ui");

        inputMin.addEventListener("change", category.priceChanged);
        inputMax.addEventListener("change", category.priceChanged);

        if (noUiSliderElement && noUiSliderElement.noUiSlider)
        {
            noUiSliderElement.noUiSlider.on("set", (value, handle) =>
            {
                if (isResettingPrice)
                    return;

                category.priceChanged();
            });
        }
    },
    clearFiltersAsync: async function ()
    {
        var checkBoxes = document.querySelectorAll("[data-product-filter] input[type='checkbox']");

        for (var checkBox of checkBoxes)
            checkBox.checked = false;

        var filterForm = document.querySelector("form[data-product-filter]");

        var priceSlider = document.querySelector("#price-filter .range-slider-ui");

        if (priceSlider)
        {
            isResettingPrice = true;

            priceSlider.noUiSlider.set([priceSlider.noUiSlider.options.range.min, priceSlider.noUiSlider.options.range.max]);

            category.priceChanged();

            isResettingPrice = false;
        }

        await submitAjaxForm(filterForm);

        price.asyncPrice();

        var parameters = new URLSearchParams(window.location.search);
        parameters.delete("params");
        parameters.delete("sf");
        parameters.delete("price");

        window.history.replaceState({}, document.title, window.location.pathname + "?" + parameters.toString());
    },
    initFilter: function ()
    {
        var filterForm = document.querySelector("form[data-product-filter]");

        if (filterForm)
            category.bindFilterForm(filterForm);
    },
    priceChanged: async function (event)
    {
        await submitAjaxForm(window.category._filterForm);

        price.asyncPrice();
    },
    removeFilter: function (property, value)
    {
        var parameters = new URLSearchParams(window.location.search);

        if (property == "sf")
        {
            var checkBox = document.querySelector(`input[name='StaticFilter'][value='${value}']`);

            if (checkBox)
            {
                checkBox.checked = false;

                // trigger change event
                checkBox.dispatchEvent(new Event("change", { bubbles: true }));
            }

            value = value.toLowerCase();

            var staticFilters = (parameters.get("sf") || "").split(',');
            staticFilters = staticFilters.filter(item => item != value);
            staticFilters = staticFilters.join(',');

            parameters.set("sf", staticFilters);
        }
        else if (property == "price")
        {
            var priceSlider = document.querySelector("#price-filter .range-slider-ui");

            isResettingPrice = true;

            priceSlider.noUiSlider.set([priceSlider.noUiSlider.options.range.min, priceSlider.noUiSlider.options.range.max]);

            category.priceChanged();

            isResettingPrice = false;

            parameters.delete("price");
        }
        else
        {
            var input = document.querySelector(`#filter-${property} input[type='hidden'][name$='.Value'][value='${value}']`);
            var parent = null;
            var checkBox = null;

            if (input)
                parent = input.parentNode;

            if (parent)
                checkBox = parent.querySelector("input[type='checkbox']");

            if (checkBox)
            {
                checkBox.checked = false;

                // trigger change event
                checkBox.dispatchEvent(new Event("change", { bubbles: true }));
            }

            var properties = (parameters.get("params") || "").split(';');

            for (var i = 0; i < properties.length; i++)
            {
                var propertyValue = properties[i].split('-');

                if (propertyValue[0] != property)
                    continue;

                var values = propertyValue[1].split(',');

                for (var j = 0; j < values.length; j++)
                {
                    if (values[j] != value)
                        continue;

                    values.splice(j, 1);

                    break;
                }

                if (values.length > 0)
                    properties[i] = property + "-" + values.join(',');
                else
                    properties.splice(i, 1);

                break;
            }

            properties = properties.join(';');

            parameters.set("params", properties);
        }

        window.history.replaceState({}, document.title, window.location.pathname + "?" + parameters.toString());
    },
    updateParamUrl: function ()
    {
        var filterForm = document.querySelector("form[data-product-filter]");

        if (!filterForm)
            return;

        var properties = [];
        var staticFilters = [];
        var priceFilter = null;

        var checkBoxes = filterForm.querySelectorAll(".form-check, div[data-checkbox]");

        checkBoxes.forEach(checkBox =>
        {
            var input = checkBox.querySelector("input[type=checkbox]");

            if (!input.checked)
                return;

            if (input.dataset.static == "true")
            {
                staticFilters.push(input.value.toLowerCase());

                return;
            }

            var propertyId = checkBox.querySelector("input[name$=PropertyId]").value;
            var valueId = checkBox.querySelector("input[name$=Value]").value;

            if (!properties[propertyId])
                properties[propertyId] = [];

            properties[propertyId].push(valueId);
        });

        var params = [];

        for (var propertyId in properties)
        {
            var values = properties[propertyId];
            var joinedValues = values.join(",");

            params.push(propertyId + "-" + joinedValues);
        }

        params = params.join(";");

        var staticFiltersString = staticFilters.join(",");

        var priceFilterMin = filterForm.querySelector("input[name='PriceFilter[0]'");
        var priceFilterMax = filterForm.querySelector("input[name='PriceFilter[1]'");

        if (priceFilterMin && priceFilterMax)
        {
            var noUiSliderElement = filterForm.querySelector("#price-filter .range-slider-ui");

            if (noUiSliderElement && noUiSliderElement.noUiSlider)
            {
                var values = noUiSliderElement.noUiSlider.get(true);

                var range = noUiSliderElement.noUiSlider.options.range;

                var isInactive = range.min == values[0] && range.max == values[1];

                priceFilter = isInactive
                    ? null
                    : `${values[0]},${values[1]}`;
            }
        }

        var parameters = new URLSearchParams(window.location.search);
        parameters.set("params", params);
        parameters.set("sf", staticFiltersString);

        if (priceFilter)
            parameters.set("price", priceFilter);

        window.history.replaceState({}, document.title, window.location.pathname + "?" + parameters.toString());
    }
};

document.addEventListener("DOMContentLoaded", function (e)
{
    category.initFilter();
});

//export default productFilter;